import React, { ReactNode, useEffect, useState } from 'react';
import { AppBar, Divider, Drawer, IconButton, Toolbar } from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import styles from './Layout.module.scss';
import Navigation from '@nal/components/Navigation/Navigation';
import { Navigations } from '@nal/navigation';
import CurrentUser from '../CurrentUser/CurrentUser';
import { useDispatch } from 'react-redux';
import { CurrentUserAction } from '../CurrentUser/store/actions';

type LayoutPropType = {
    children: ReactNode;
};

const Layout: React.FC<LayoutPropType> = ({ children }) => {
    const [open, setOpen] = useState(true);
    const navigations = Navigations;
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch({
            type: CurrentUserAction.GET_ME
        });
    }, []);

    return (
        <>
            <AppBar position="relative" className={styles.AppBar}>
                <Toolbar className={`${styles.Toolbar} ${open ? styles.ToolbarOpen : ''}`}>
                    <CurrentUser />
                </Toolbar>
            </AppBar>
            <Drawer
                variant="persistent"
                anchor="left"
                open={true}
                className={`${styles.Drawer} ${open ? styles.DrawerOpen : ''}`}
            >
                <div className={`${styles.ToolbarHeader} ${!open ? styles.close : ''}`}>
                    <IconButton onClick={() => setOpen(!open)}>
                        {open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                    </IconButton>
                </div>
                <Divider />
                <Navigation open={open} navigations={navigations}></Navigation>
            </Drawer>

            <main className={`${styles.Main} ${open ? styles.MainOpen : ''}`}>
                <React.Fragment>{children}</React.Fragment>
            </main>
        </>
    );
};

export default Layout;
